import {
  AUTOMATION_ACTION,
  AUTOMATION_STATE,
} from 'services/Automation2Service';
import { useTranslation } from 'react-i18next';
import { isExecutionImmutable } from '../AutomationsPage/helpers';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { StyledActionCell, StyledNoActionsCell } from './styles';

const ActionWidget = ({
  data: automation,
  onUpdateAutomation,
  scrollContainerRef,
  canStart = true,
  ...props
}) => {
  const { t } = useTranslation();
  const { automationActive, debugMode } = automation;
  const isDebugActive = automationActive && debugMode === 'active';

  const scrollContainer =
    scrollContainerRef?.current || document.documentElement;

  const options = useMemo(() => {
    if (!canStart) {
      return [];
    }
    const options = [];

    if (!isExecutionImmutable(automation)) {
      switch (automation.status) {
        case AUTOMATION_STATE.PAUSED:
          automationActive &&
            options.push({
              value: AUTOMATION_ACTION.RESUME,
              label: t('Resume Agentic Workflow'),
            });
          break;

        case AUTOMATION_STATE.ACTIVE: {
          if (isDebugActive) {
            options.push({
              value: AUTOMATION_ACTION.DEBUG_AUTOMATION,
              label: t('Debug Agentic Workflow'),
            });
          } else {
            options.push({
              value: AUTOMATION_ACTION.PAUSE,
              label: t('Pause Agentic Workflow'),
            });
          }
          break;
        }

        case AUTOMATION_STATE.PAUSED_BY_AUTOMATION:
        case AUTOMATION_STATE.IN_QUEUE:
          options.push({
            value: AUTOMATION_ACTION.PAUSE,
            label: t('Pause Agentic Workflow'),
          });
          break;

        case AUTOMATION_STATE.PAUSED_BY_FAILURE:
          automationActive &&
            options.push(
              {
                value: AUTOMATION_ACTION.RESUME,
                label: t('Retry and Resume'),
              },
              {
                value: AUTOMATION_ACTION.SKIP_STEP_AND_RESUME,
                label: t('Skip Step & Resume'),
              }
            );
          break;
        default:
      }
      options.push({
        value: AUTOMATION_ACTION.CANCEL,
        label: t('Cancel Agentic Workflow'),
      });
    }

    options.push({
      value: AUTOMATION_ACTION.EXECUTION_HISTORY,
      label: t('View Execution History'),
    });

    return options;
  }, [canStart, automation, t, automationActive, isDebugActive]);

  const [open, setOpen] = useState(false);

  const onClose = useCallback(() => {
    setOpen(false);
  }, []);

  const onSelectAction = ({ value }, data) => {
    onUpdateAutomation(data, value);
    onClose();
  };

  const onOpen = () => {
    setOpen(true);
  };

  useEffect(() => {
    if (open) {
      scrollContainer.addEventListener('scroll', onClose, { once: true });
    } else {
      scrollContainer.removeEventListener('scroll', onClose);
    }

    return () => {
      scrollContainer.removeEventListener('scroll', onClose);
    };
  }, [open, scrollContainer, onClose]);

  return options.length ? (
    <StyledActionCell
      title={t('Edit Agentic Workflow Execution')}
      options={options}
      data={automation}
      onSelectAction={onSelectAction}
      menuType="absolute"
      open={open}
      onOpen={onOpen}
      onClose={onClose}
      {...props}
    />
  ) : (
    <StyledNoActionsCell {...props} />
  );
};

export default ActionWidget;
